import { render } from "./menuWidget.vue?vue&type=template&id=f8efdfb0&scoped=true"
import script from "./menuWidget.vue?vue&type=script&lang=js"
export * from "./menuWidget.vue?vue&type=script&lang=js"

import "./menuWidget.vue?vue&type=style&index=0&id=f8efdfb0&scoped=true&lang=css"

import exportComponent from "/Users/song/Desktop/pro/homePage/沙漠传说/desertlegendhomepage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8efdfb0"]])

export default __exports__